import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { Text } from '../../../Elements/Elements';

import classes from './Legend.module.scss';

const Legend = () => {
  const { t } = useTranslation(['activity']);

  return (
    <ul className={classes.legend}>
      <li className={classes.item}>
        <Text size={2} className={cn(classes.text, classes.blue)}>
          {t('activity:customers.ESSENTIALS')}
        </Text>
      </li>
      <li className={classes.item}>
        <Text size={2} className={cn(classes.text, classes.green)}>
          {t('activity:customers.STANDART')}
        </Text>
      </li>
      <li className={classes.item}>
        <Text size={2} className={cn(classes.text, classes.yellow)}>
          {t('activity:customers.PREMIUM')}
        </Text>
      </li>
      <li className={classes.item}>
        <Text size={2} className={cn(classes.text, classes.red)}>
          {t('activity:customers.ENTERPRISE')}
        </Text>
      </li>
    </ul>
  );
};

export default Legend;
